/**
 * 솔루션 도입 프로세스 섹션 클래스.
 *
 * 원본 Emotion styled 컴포넌트를 Tailwind 클래스 문자열로 옮겼다.
 * Tailwind 를 important 로 임포트하고 있어 같은 속성을 건드리는 유틸리티를 두 개 쓰면
 * 승자가 CSS 출력 순서로 정해지므로, 한 속성당 하나의 유틸리티만 남기고
 * 반응형 덮어쓰기는 동일 longhand(lg: 접두사)로만 처리한다.
 */

export const processListContainer = 'relative';

export const processListWrap =
  'mt-[50px] flex flex-col gap-[40px] lg:mt-[80px] lg:flex-row';

export const processList = 'lg:relative lg:flex-1';

/**
 * lg 에서만 padding-top 과 ::before 원형 마커가 붙는다.
 * ::before 는 position 이 있는 조상(ProcessList 의 lg:relative)을 기준으로 잡힌다.
 */
export const processListInner =
  "lg:pt-[31px] lg:before:absolute lg:before:left-0 lg:before:top-[-7px] lg:before:block lg:before:h-[14px] lg:before:w-[14px] lg:before:rounded-full lg:before:bg-[#7b3dff] lg:before:content-['']";

/** transform-origin: 0 0 == origin-top-left (framer-motion 이 scaleX 를 인라인으로 애니메이션) */
export const processLine =
  'absolute top-0 h-[1px] w-full origin-top-left bg-apps-brandGrayWhite opacity-20';

/** 모바일에서만 앞에 원형 불릿이 붙고 lg 에서는 숨긴다. */
export const listStep =
  "text-[14px] font-medium leading-[140%] tracking-[-0.28px] before:mr-[8px] before:inline-block before:h-[8px] before:w-[8px] before:rounded-full before:bg-apps-brandPrimary500 before:content-[''] lg:text-[16px] lg:tracking-[-0.32px] lg:before:hidden";

/** margin: 8px 0 4px -> lg 에서 margin: 8px 0 (bottom 만 8px 로 바뀐다) */
export const listTitle =
  'mb-[4px] mt-[8px] text-[22px] font-bold leading-[160%] tracking-[-0.44px] lg:mb-[8px]';

/** 원본에 base font-size 가 없어 상속값을 그대로 쓴다. lg 에서만 18px. */
export const listDesc =
  'font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:text-[18px] lg:leading-[160%] lg:tracking-[-0.36px]';

export const listExtra =
  'mt-[4px] text-[14px] font-medium leading-[140%] tracking-[-0.28px] text-apps-brandGray300 lg:mt-[8px]';
